"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Removes all non-numeric characters, including decimal separators.
 * Not appropriate for floating point numbers.
 *
 * Useful for stripping phone numbers, Social Security Number, etc.
 *
 * @param {string} number
 */
var removeNonNumericCharacters = function removeNonNumericCharacters(number) {
  return number.replace(/\D/g, '');
};

var _default = removeNonNumericCharacters;
exports["default"] = _default;